const HEX_TO_VAR: Record<string, string> = {
  '#EF4444': '--cat-red',
  '#F97316': '--cat-orange',
  '#F59E0B': '--cat-amber',
  '#10B981': '--cat-emerald',
  '#06B6D4': '--cat-cyan',
  '#3B82F6': '--cat-blue',
  '#6366F1': '--cat-indigo',
  '#8B5CF6': '--cat-violet',
  '#EC4899': '--cat-pink',
  '#64748B': '--cat-slate',
}

/** hex를 CSS var() 참조로 변환. 미등록 hex는 원본 반환 */
export function getCategoryColorStyle(hex: string): string {
  const varName = HEX_TO_VAR[hex.toUpperCase()]
  return varName ? `var(${varName})` : hex
}

/** hex를 배경용 CSS var() 참조로 변환 (기존 `${hex}20` 대체) */
export function getCategoryBgStyle(hex: string): string {
  const varName = HEX_TO_VAR[hex.toUpperCase()]
  return varName ? `var(${varName}-bg)` : `${hex}20`
}

/** getComputedStyle로 실제 색상값 반환 (Chart.js canvas용) */
export function getComputedCategoryColor(hex: string): string {
  const varName = HEX_TO_VAR[hex.toUpperCase()]
  if (!varName) return hex
  return getComputedStyle(document.documentElement)
    .getPropertyValue(varName).trim() || hex
}
